import React, { Component, useEffect, useContext } from 'react';
import {
  Link,
  withRouter
} from "react-router-dom";
import '../home/home-view.css';
import logo from "../../assets/logo.png";
import { SocketContext, initSocket } from "../../socket";
import { getActiveJob } from '../../reducers/calendar';
import { useDispatch } from '../../reducers/store';

import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBIcon,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBCollapse,
  MDBNavbarToggler
} from 'mdbreact';

class Header extends Component {
  state = {
    collapseID: '',
    modal1: false,
    isOpen: false,
    searchOpen: false
  };

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  toggleClose = () => {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  toggleSearch = () => {
    this.setState({ searchOpen: !this.state.searchOpen });
  }

  closeSearch = () => {
    this.setState({ searchOpen: false });
    this.props.dispatchEnterSearch(undefined);
  }

  componentDidMount() {
    this.props.getRooms();


    //  initSocket(this.props.user._id);

    // this.props.getProfile();
  }

  logout = () => {
    this.props.logout();
  }

  handleMenuToggle = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      document.body.classList.toggle('sidebar-open');
    } else {
      document.body.classList.toggle('sidebar-collapse');
    }
  }

  render() {

    const Socket = () => {
      const disp = useDispatch();

      // useContext(SocketContext);
      //  console.log(this.props.user)
      const socket = initSocket(this.props.user._id)
      const userId = this.props.user._id;
      //  console.log(socket);

      useEffect(() => {

        socket.on("yourRooms", (rooms) => {
          console.log('yourRooms', rooms);
          rooms.forEach(room => {
            //TODO send over all
            socket.emit("subscribe", room);
          });
        });

        socket.on("chat message", msg => {
          console.log('message', msg);
          this.props.receiveMessage(msg);
        });

        socket.on("updateActiveJobs", msg => {
          console.log('message', msg);
          disp(getActiveJob(msg.id));
        });

        socket.on("connect", () => {
          console.log('connect');
          socket.emit("identity", userId);
        });

        socket.on("disconnect", () => {
          console.log('disconnect');
        });

        return () => {
          // before the component is destroyed
          // unbind all event handlers used in this component
          socket.off("yourRooms");
          socket.off("chat message");
          socket.off("connect");
          socket.off("disconnect");
          socket.off("updateActiveJobs");
        };
      }, [socket, userId]);

      return (<></>);
    }

    return (
      <nav className="main-header" style={{
        background: '#1a3a4a',
        padding: '0 20px',
        height: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        zIndex: 100,
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      }}>
        <Socket />

        {/* Left side - Menu toggle */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <button
            onClick={this.handleMenuToggle}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: 'none',
              color: 'white',
              fontSize: 16,
              cursor: 'pointer',
              padding: '8px 10px',
              borderRadius: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Toggle menu"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>

        {/* Right side - Search and User */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Search - only show on /statuses route */}
          {this.props.location && this.props.location.pathname === '/statuses' && (
            <div style={{ position: 'relative' }}>
              {!this.state.searchOpen && (
                <button
                  onClick={this.toggleSearch}
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: 'none',
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: 14,
                    cursor: 'pointer',
                    padding: '8px 12px',
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
                >
                  <i className="fas fa-search"></i>
                </button>
              )}

              {this.state.searchOpen && (
                <div style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  background: 'white',
                  borderRadius: 6,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  padding: 8,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  minWidth: 280
                }}>
                  <input
                    onChange={(v) => this.props.dispatchEnterSearch(v.target.value)}
                    value={this.props.search || ''}
                    type="search"
                    placeholder="Search..."
                    autoFocus
                    style={{
                      flex: 1,
                      border: 'none',
                      outline: 'none',
                      padding: '8px 12px',
                      fontSize: 14,
                      borderRadius: 4
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Escape') {
                        this.closeSearch();
                      }
                    }}
                  />
                  <button
                    onClick={this.closeSearch}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      color: '#999',
                      cursor: 'pointer',
                      padding: '8px 10px',
                      borderRadius: 4,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#f5f5f5';
                      e.currentTarget.style.color = '#333';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = '#999';
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              )}
            </div>
          )}

          {/* User Dropdown */}
          <div className="dropdown dropleft">
            <button
              data-toggle="dropdown"
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                color: 'white',
                width: 36,
                height: 36,
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="far fa-user"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right" style={{
              borderRadius: 8,
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              border: '1px solid #eee',
              padding: 8,
              minWidth: 180,
              marginTop: 8
            }}>
              <Link to="/settings" className="dropdown-item" style={{
                padding: '10px 16px',
                borderRadius: 6,
                color: '#333',
                fontSize: 14
              }}>
                <i className="fas fa-cog" style={{ marginRight: 10, color: '#19a6b7' }}></i>
                Profile Settings
              </Link>
              <div style={{ height: 1, background: '#eee', margin: '8px 0' }}></div>
              <a onClick={() => this.logout()} className="dropdown-item" style={{
                padding: '10px 16px',
                borderRadius: 6,
                color: '#e84651',
                fontSize: 14,
                cursor: 'pointer'
              }}>
                <i className="fas fa-sign-out-alt" style={{ marginRight: 10 }}></i>
                Log out
              </a>
            </div>
          </div>
        </div>
      </nav>
    );

    return (
      <MDBNavbar color='white' dark expand='md' fixed='top' scrolling>

        <MDBNavbarBrand href='/' className='py-0 font-weight-bold'>
          <img style={{ height: '2.5rem' }} src={logo} alt="Logo" />
        </MDBNavbarBrand>
        <MDBNavbarToggler onClick={this.toggleCollapse} />
        <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
          <MDBNavbarNav left>
            {this.props.company && this.props.company._id && <MDBNavItem>
              <MDBNavLink to="/invoices" onClick={this.toggleClose}>Invoices</MDBNavLink>
            </MDBNavItem>}
            {this.props.company && this.props.company._id && <MDBNavItem>
              <MDBNavLink to="/invoiceTemplates" onClick={this.toggleClose}>invoiceTemplates</MDBNavLink>
            </MDBNavItem>}
            {this.props.company && this.props.company._id && <MDBNavItem>
              <MDBNavLink to="/templates" onClick={this.toggleClose}>templates</MDBNavLink>
            </MDBNavItem>}
          </MDBNavbarNav>

          <MDBNavbarNav right>
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <MDBIcon className="pr-2 primary-text" icon="user" />{this.props.user && this.props.user.name}
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-default">
                  {(!this.props.user || !this.props.user._id) && <MDBDropdownItem><MDBNavLink className="grey-text" to="/login" onClick={this.toggleClose}>Login</MDBNavLink></MDBDropdownItem>}
                  {this.props.user && this.props.user._id && <MDBDropdownItem><MDBNavItem className="grey-text" onClick={this.logout}>logout</MDBNavItem></MDBDropdownItem>}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
          </MDBNavbarNav>
        </MDBCollapse>
      </MDBNavbar>
    );
  }
};

const HeaderWithRouter = withRouter(Header);
export { HeaderWithRouter as Header };
